<template>
  <header>
    <div class="button-wrap" v-if="!hideButton">
      <!-- <div class="button-name" :class="{ active: NICK_NAME }" @click="login"> -->
      <!-- {{ NICK_NAME ? NICK_NAME : "Log In" }} -->
      <!-- </div> -->
      <div class="works-filter" :class="{logged:NICK_NAME}" >
        <div class="works-search">
          <!-- <div class="iconfont-search" @click="searchList">
          <i class="iconfont iconicon-chaxun"></i>
        </div> -->
          <div class="works-search-box">
            <input
              type="text"
              @keydown.enter="searchList"
              placeholder="Search"
              v-model="searchContent"
              class="works-search-input"
            />
          </div>
          <div class="search-icon" @click="searchList" ></div>
        </div>
      </div>
      <div class="button-login" v-show="!NICK_NAME" @click="login" ></div>
      <div class="login-suc" v-show="NICK_NAME" >{{NICK_NAME}}</div>
      <div class="button-out" v-show="NICK_NAME"  @click="logout" ></div>
      <div class="button-rules" @click="rulesOpen"></div>
      <div class="button-submit" @click="toUpload"></div>
    </div>
  </header>
</template>

<script>
import { mapState } from 'vuex';
import { EventBus } from '../plugins/bus';
export default {
  name: 'Header',
  components: {},
  data: () => ({
    hideButton: false,
    searchContent:"",
  }),
  created() {
    this.hideButton = this.$route.meta.hideButton;
  },
  mounted() {},
  watch: {
    searchContent(val){
      console.log('123123',val)
      EventBus.$emit("searchValueChange",val)
    }
  },
  computed: {
    ...mapState({
      NICK_NAME: (state) => state.User.NICK_NAME,
      ART_SUBMIT_ENABLE: (state) => state.Config.ART_SUBMIT_ENABLE,
      COS_SUBMIT_ENABLE: (state) => state.Config.COS_SUBMIT_ENABLE,
      LCOS_SUBMIT_ENABLE: (state) => state.Config.LCOS_SUBMIT_ENABLE,
    }),
  },
  methods: {
    logout(){
      this.$store
        .dispatch('User/logout')
        .then((v) => {
          if (v.retcode == 2000) {
            this.$router.replace({ path: '/' });
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    searchList(){
      EventBus.$emit("searchKeyDown")
    },
    login() {
      if (!this.NICK_NAME) {
        this.$store.commit('LoginMask/SET_MASK_ACTIVE', true);
      } else {
        this.$store
          .dispatch('User/logout')
          .then((v) => {
            if (v.retcode == 2000) {
              this.$router.replace({ path: '/' });
            }
          })
          .catch((e) => {
            console.log(e);
          });
      }
    },
    toUpload() {
      window.gtag('event', `click_submit`);
      if (
        this.ART_SUBMIT_ENABLE ||
        this.COS_SUBMIT_ENABLE ||
        this.LCOS_SUBMIT_ENABLE
      ) {
        this.$store
          .dispatch('User/getUserInfo')
          .then((v) => {
            this.$router.push({ path: 'upload' });
          })
          .catch((e) => {
            // 获取用户信息
            console.log(e);
          });
      } else {
        alert(
          'The submission period has ended. Please check our official social media account for any update regarding this event. Thank you for your support!'
        );
      }
    },
    rulesOpen() {
      window.gtag('event', `click_rules`);
      this.$store.commit('Home/SET_RULES_POPUP_STATE', true);
    },
  },
};
</script>

<style lang="scss" scoped>
header {
  width: 100%;
  height: 0;
  padding-bottom: 22.24%;
  background: url(../assets/images/header/banner.png) no-repeat;
  background-size: 100%;
  position: relative;
  .button-wrap {
    position: absolute;
    top: pxTorem(18px);
    right: pxTorem(15px);
    display: flex;
    align-items: center;
    .works-filter {
      position: relative;
      margin-right: pxTorem(238px);
      border-radius: pxTorem(24px);
      box-sizing: border-box;
      width: pxTorem(374px);
      height: pxTorem(47px);
      line-height: pxTorem(46px);
      border: 2px solid #ffffff;
      background: rgba(255, 255, 255, 0.5);
      box-sizing: border-box;
      display: flex;
      box-shadow: 10px 10px 18px 11px rgba(0,0,0,0.22);
      .works-search {
        width: 100%;
        font-size: 0;
        display: flex;
        box-sizing: border-box;
        .works-search-box {
          flex: 1;
          order: 0;
          .works-search-input {
            display: block;
            outline: pxTorem(2px) solid #ffffff;
            width: 83%;
            height: 100%;
            @include clearInput;
            color: rgb(56, 56, 56);
            font-size: pxTorem(18px);
          }
        }
        .search-icon {
          cursor: pointer;
          position: absolute;
          top: pxTorem(-2px);
          right: pxTorem(-3px);
          z-index: 2;
          width: pxTorem(47px);
          height: pxTorem(47px);
          background-image: url(../assets/images/header/search.png);
          background-size: 100% 100%;
          transition: all 0.3s;
          &:hover {
            background-image: url(../assets/images/header/search-act.png);
          }
        }
        // .iconfont-search {
        //   cursor: pointer;
        //   order: 2;
        //   font-size: pxTorem(18px);
        //   color: #fff;
        //   padding: 0 pxTorem(10px);
        //   background: #0062d0;
        //   .iconicon-chaxun {
        //     font-size: pxTorem(20px);
        //   }
        //   .search-label {
        //     white-space: nowrap;
        //   }
        // }
      }
    }
    .logged{
      margin-right: pxTorem(34px);
    }
    .button-name {
      height: pxTorem(45px);
      width: pxTorem(150px);
      position: absolute;
      right: pxTorem(180px);
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      background: url(../assets/images/header/name.png);
      background-size: 100% 100%;
      font-family: 'Noto Sans KR', sans-serif;
      cursor: pointer;
      text-align: center;
      font-weight: bold;
      color: white;
      font-size: pxTorem(19px);
      line-height: pxTorem(60px);
      &.active {
        background: url(../assets/images/header/nameActive.png);
        background-size: 100% 100%;
      }
    }
    .button-login {
      cursor: pointer;
      width: pxTorem(41px);
      height: pxTorem(53px);
      background-image: url(../assets/images/header/login.png);
      background-size: 100% 100%;
      transition: all 0.3s;
      margin-right: pxTorem(34px);
      &:hover {
        background-image: url(../assets/images/header/login-act.png);
      }
    }
    .login-suc {
      margin-right: pxTorem(21px);
      white-space: nowrap; /* 确保文本在一行内显示 */
      overflow: hidden; /* 超出部分隐藏 */
      text-overflow: ellipsis; /* 使用打点省略 */
      max-width: pxTorem(189px);
      height: pxTorem(36px);
      font-weight: 800;
      font-size: pxTorem(24px);
      color: #fffffe;
      line-height: pxTorem(36px);
    }
    .button-out {
      cursor: pointer;
      width: pxTorem(57px);
      height: pxTorem(53px);
      background-image: url(../assets/images/header/logout.png);
      background-size: 100% 100%;
      transition: all 0.3s;
      margin-right: pxTorem(29px);
      &:hover {
        background-image: url(../assets/images/header/logout-act.png);
      }
    }
    .button-submit {
      cursor: pointer;
      width: pxTorem(168px);
      height: pxTorem(63px);
      background-image: url(../assets/images/header/sub.png);
      background-size: 100% 100%;
      transition: all 0.3s;
      &:hover {
        background-image: url(../assets/images/header/sub-act.png);
      }
    }

    .button-rules {
      cursor: pointer;
      width: pxTorem(59px);
      height: pxTorem(53px);
      margin-right: pxTorem(27px);
      background-image: url(../assets/images/header/rule.png);
      background-size: 100% 100%;
      transition: all 0.3s;
      &:hover {
        background-image: url(../assets/images/header/rule-act.png);
      }
    }
  }
}
</style>
